import * as Types from 'src/actions/project/change-data/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import ProjectData from 'src/value-objects/ProjectData';

export interface ChangeProjectData extends Action {
  type: Types.CHANGE_PROJECT_DATA;
  payload: ProjectData;
}

export type ChangeProjectDataAction = ChangeProjectData;

export const changeProjectData: ActionCreator<ChangeProjectData> = (project: ProjectData) => (
  {
    type: Types.CHANGE_PROJECT_DATA,
    payload: project
  }
);


// WEBPACK FOOTER //
// ./src/actions/project/change-data/ChangeProjectData.actions.tsx